import { render, staticRenderFns } from "./DescriptionForm.vue?vue&type=template&id=26ca8ed6&"
import script from "./DescriptionForm.vue?vue&type=script&lang=js&"
export * from "./DescriptionForm.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionForm.vue?vue&type=style&index=0&id=26ca8ed6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports